<div class="w-full space-y-6">
  <div class="w-full pt-4">
    <details class="group rounded-[2rem] bg-white/30 transition-all duration-300">
      <summary
        class="list-none cursor-pointer rounded-[2rem] px-5 py-5 text-center transition-colors hover:bg-white/50"
      >
        <div class="flex flex-col items-center justify-center">
          <span
            class="text-[10px] font-bold uppercase tracking-[0.18em] text-[#3a332c]/40 transition-colors group-hover:text-[#3a332c]/55"
          >
            Sobre Dinno divisor
          </span>

          <h4 class="mt-1 text-sm font-bold text-[#1f1b16]">
            Una herramienta pensada para hacer más simple dividir la cuenta
          </h4>

          <div
            class="mt-3 text-[#3a332c]/25 transition-transform duration-300 group-open:rotate-180"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2.5"
            >
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>
      </summary>

      <div class="px-6 pb-7 pt-1">
        <div class="mx-auto max-w-[34rem] space-y-4 text-sm leading-relaxed text-[#3a332c]/78">
          <p>
            <strong class="text-[#1f1b16]">Dinno divisor</strong> es la versión pública de una
            herramienta que forma parte de <strong class="text-[#1f1b16]">Dinno</strong>, una
            aplicación pensada para gestionar pedidos y menú digital en restaurantes y bares.
          </p>

          <p>
            Nació como un complemento para acompañar esa experiencia y resolver una situación muy
            común: que dividir la cuenta al final no sea una discusión ni un cálculo improvisado,
            sino algo claro, rápido y ordenado.
          </p>

          <p>
            Como creemos que esta herramienta también puede ser útil fuera de los lugares que usan
            Dinno, decidimos ofrecer esta modalidad pública para que
            <strong class="text-[#1f1b16]"
              >pueda usarse en cualquier salida, en cualquier lugar</strong
            >.
          </p>

          <p>
            Es un proyecto desarrollado de manera independiente, que sigue creciendo paso a paso
            para hacer más simple una situación cotidiana que todos vivimos.
          </p>

          <div class="border-t border-black/[0.04] pt-3">
            <p class="text-[11px] font-medium text-[#1f1b16]/38 italic tracking-tight text-center">
              Hecho en Mar del Plata, con la idea de que dividir la cuenta sea la parte más fácil.
            </p>
          </div>
        </div>
      </div>
    </details>
  </div>

  @if (showThankYouBanner()) {
    <div
      class="rounded-[2rem] bg-gradient-to-br from-green-50 to-emerald-50 border border-green-200/60 p-5 shadow-sm animate-in fade-in zoom-in duration-500 relative overflow-hidden text-left"
    >
      <button
        (click)="resetDonationStatus()"
        class="absolute top-4 right-4 text-green-800/20 hover:text-green-800 transition-colors"
      >
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="3">
          <path d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      <div class="flex items-center gap-4 pr-6">
        <div
          class="w-12 h-12 flex-shrink-0 bg-white rounded-2xl flex items-center justify-center shadow-sm border border-green-100"
        >
          <img
            src="https://res.cloudinary.com/dgjd3ybs1/image/upload/v1774817779/dinno-ok_xtfwcb.png"
            alt="Dinno Ok"
            class="w-full h-full object-contain"
          />
        </div>
        <div>
          <h3 class="text-sm font-black text-green-900">¡Muchísimas gracias!</h3>
          <p class="text-[10px] text-green-800/80 leading-relaxed font-medium mt-0.5">
            Si ya colaboraste, ¡mil gracias! Si no pudiste, no te preocupes, Dinno te quiere igual.
          </p>
        </div>
      </div>
    </div>
  } @else {
    <button
      (click)="onTecitoClick()"
      class="relative w-full overflow-hidden flex items-center bg-white border border-black/[0.08] rounded-[2rem] p-4 shadow-sm active:scale-[0.96] transition-all group hover:border-orange-200 hover:shadow-md"
    >
      <div
        class="w-14 h-14 flex-shrink-0 bg-[#fcfaf7] rounded-2xl overflow-hidden mr-4 shadow-inner"
      >
        <img
          src="https://res.cloudinary.com/dgjd3ybs1/image/upload/v1774804184/dinno-cafecito_b4fgfi.png"
          alt="Dinno café"
          class="w-full h-full object-contain group-hover:scale-110 group-hover:-rotate-3 transition-all duration-300"
        />
      </div>
      <div class="flex-1 text-left">
        <h4 class="text-sm font-black text-[#1f1b16]">¿Te sirvió la app?</h4>
        <p class="text-[10px] leading-tight text-[#3a332c]/60 font-medium pr-8">
          Si Dinno te ahorró una discusión, podés invitarle un tecito.
        </p>
      </div>
      <div class="ml-auto text-black/10 group-hover:text-orange-500 transition-colors">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-6 h-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="3"
        >
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      </div>
    </button>
  }
</div>
